<template>
<div class="kt-portlet__head-toolbar">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>